"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jquery_1 = __importDefault(require("jquery"));
require("jquery-validation");
const defaults = {
    selector: {
        start: 'input[name="timespan_startdate"]',
        end: 'input[name="timespan_enddate"]',
        altStart: "#timespan_startdate",
        altEnd: "#timespan_enddate",
        button: "#timespan_show"
    },
    base_url_var: "base_url",
    defaults: {
        dateFormat: "dd.mm.yy",
        firstDay: 1,
        prevText: '<i class="fa fa-chevron-left"></i>',
        nextText: '<i class="fa fa-chevron-right"></i>',
        altFormat: "yy-mm-dd"
    },
    messages: {
        validate: {
            start: "Enter a start date.",
            end: "Enter an end date."
        }
    }
};
const TimeSpanPickerPlugin = function (app, config) {
    const settings = jquery_1.default.extend(true, {}, defaults, config);
    this.init = () => {
        if (typeof jquery_1.default.fn.datepicker !== "function" || typeof jquery_1.default.fn.validate !== "function") {
            return;
        }
        (0, jquery_1.default)(settings.selector.start).datepicker(jquery_1.default.extend(true, {}, settings.defaults || {}, {
            altField: settings.selector.altStart
        }));
        (0, jquery_1.default)(settings.selector.end).datepicker(jquery_1.default.extend(true, {}, settings.defaults || {}, {
            altField: settings.selector.altEnd
        }));
        (0, jquery_1.default)(settings.selector.button).validate({
            rules: {
                timespan_startdate: {
                    required: true
                },
                timespan_enddate: {
                    required: true
                },
                timespan_startdate_alt: {
                    required: true
                },
                timespan_enddate_alt: {
                    required: true
                }
            },
            messages: {
                timespan_startdate: {
                    required: settings.messages.validate.start
                },
                timespan_enddate: {
                    required: settings.messages.validate.end
                }
            },
            submitHandler() {
                const startDate = (0, jquery_1.default)(settings.selector.altStart).val();
                const endDate = (0, jquery_1.default)(settings.selector.altEnd).val();
                const baseUrl = window[settings.base_url_var];
                app.goTo(`${baseUrl}${startDate}/${endDate}/`);
            },
            errorPlacement(error, element) {
                error.insertAfter(element.parent());
            }
        });
    };
    return this;
};
exports.default = TimeSpanPickerPlugin;
